<nav class="navbar">
    <div class="navbar-content">
        <div class="button-wrapper">
            <button (click)="onDemoGalleryClick()" *ngIf="showToDemoGalleryButton" mat-button>
                <mat-icon>arrow_back</mat-icon>
                <span>Choose a Scenario</span>
            </button>
        </div>
        <div class="navbar-logo">
            <img class="smart-ads-demo-logo" alt="SMART™ DCO Demo"/>
        </div>
    </div>
</nav>
<div class="app-content">
    <router-outlet></router-outlet>
</div>
